exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-module_range-boxes__ib1Nb .styles-module_event-content__3sakH {\n  font-size: 8px !important;\n}\n\n.styles-module_root__2iNXQ {\n  overflow: hidden;\n}", ""]);

// exports
